import { render, staticRenderFns } from "./TheAmounts.vue?vue&type=template&id=7ffdf0a0&"
import script from "./TheAmounts.vue?vue&type=script&lang=js&"
export * from "./TheAmounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports